// @ts-nocheck
import React, { useEffect } from 'react';
import { Flex, Slider, SliderTrack, SliderFilledTrack, SliderThumb, IconButton, Box } from '@chakra-ui/react';
import { FaPlay, FaPause, FaVolumeUp, FaVolumeMute, FaRandom, FaForward, FaBackward, FaVolumeDown } from 'react-icons/fa';

const AudioPlayer = ({ isPlaying, setIsPlaying, volume, setVolume, isMuted, setIsMuted, currentSongIndex, setCurrentSongIndex, songs, onSongChange }) => {
  const audioRef = React.useRef(null);

  useEffect(() => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.play();
      } else {
        audioRef.current.pause();
      }
    }
  }, [isPlaying, currentSongIndex, songs]);

  const togglePlayPause = () => {
    setIsPlaying(!isPlaying);
  };

  const toggleMute = () => {
    const muteStatus = !isMuted;
    setIsMuted(muteStatus);
    audioRef.current.muted = muteStatus;
  };

  const handleVolumeChange = (value) => {
    const newVolume = value / 100;
    setVolume(value);
    audioRef.current.volume = newVolume;
    setIsMuted(newVolume === 0);
  };

  const handleVolumeUp = () => {
    const newVolume = Math.min(volume + 10, 100);
    handleVolumeChange(newVolume);
  };

  const handleVolumeDown = () => {
    const newVolume = Math.max(volume - 10, 0);
    handleVolumeChange(newVolume);
  };

  const handleNextSong = () => {
    const nextIndex = (currentSongIndex + 1) % songs.length;
    setCurrentSongIndex(nextIndex);
    onSongChange(songs[nextIndex]);
  };

  const handlePrevSong = () => {
    const prevIndex = (currentSongIndex - 1 + songs.length) % songs.length;
    setCurrentSongIndex(prevIndex);
    onSongChange(songs[prevIndex]);
  };

  const handleRandomSong = () => {
    const randomIndex = Math.floor(Math.random() * songs.length);
    setCurrentSongIndex(randomIndex);
    onSongChange(songs[randomIndex]);
  };

  return (
    <>
      <Box display="flex" flexDirection="row" alignItems="center" justifyContent="center" height="100%">
        <IconButton
          icon={<FaBackward style={{ color: 'blue' }} />}
          aria-label="Previous Song"
          onClick={handlePrevSong}
          mr={2}
        />
        <IconButton
          icon={isPlaying ? <FaPause style={{ color: 'blue' }} /> : <FaPlay style={{ color: 'blue' }} />}
          aria-label={isPlaying ? "Pause" : "Play"}
          onClick={togglePlayPause}
          mr={2}
        />
        <IconButton
          icon={<FaForward style={{ color: 'blue' }} />}
          aria-label="Next Song"
          onClick={handleNextSong}
          mr={2}
        />
        <IconButton
          icon={<FaRandom style={{ color: 'blue' }} />}
          aria-label="Random Song"
          onClick={handleRandomSong}
          mr={2}
        />
        <IconButton
          icon={<FaVolumeDown style={{ color: 'blue' }} />}
          aria-label="Volume Down"
          onClick={handleVolumeDown}
          mr={2}
        />
        <IconButton
          icon={isMuted || volume === 0 ? <FaVolumeMute style={{ color: 'blue' }} /> : <FaVolumeMute style={{ color: 'blue' }} />}
          aria-label="Mute/Unmute"
          onClick={toggleMute}
          mr={2}
        />
        <IconButton
          icon={<FaVolumeUp style={{ color: 'blue' }} />}
          aria-label="Volume Up"
          onClick={handleVolumeUp}
          mr={2}
        />
        <Slider
          aria-label="Volume Control"
          value={volume}
          min={0}
          max={100}
          onChange={handleVolumeChange}
          width="100px"
          color={isMuted ? "red" : "blue"}
        >
          <SliderTrack>
            <SliderFilledTrack />
          </SliderTrack>
          <SliderThumb />
        </Slider>
      </Box>
      <audio ref={audioRef} src={songs[currentSongIndex].src} />
    </>
  );
};

export default AudioPlayer;
